import { queryOptions } from '@tanstack/react-query';

import { UserApi } from '@api/UserApi';

export const userSiteProfileKeys = {
    all: ['userSiteProfiles'] as const,
    lists: () => [...userSiteProfileKeys.all, 'list'] as const,
    byUserId: (userId: string) => [...userSiteProfileKeys.lists(), { userId }] as const,
};

export const userSiteProfileQueryOptions = {
    byUserId: (userId: string) =>
        queryOptions({
            queryKey: userSiteProfileKeys.byUserId(userId),
            queryFn: () => UserApi.getSiteProfile(userId),
        }),
};
